import { Button } from "components/DesignSystem/Button/Button";
import { Snackbar } from "components/DesignSystem/Snackbar/Snackbar";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/store";
import {
  closeSimilarTxnsSnackbar,
  openSimilarTxnsModal,
} from "store/slices/similarTransactions";
import { Transactions } from "types/Models/books";
import { pluralize } from "utils/pluralize";

export const AutoAssignSnackbar = () => {
  const dispatch = useDispatch();
  const { isSnackbarOpen, updateTxnResponse } = useSelector(
    (state: RootState) => state.similarTransactions
  );

  const { group_categorization } = updateTxnResponse as Transactions;
  const {
    similar_merchant_txns_count,
    merchant_data_name,
    transaction_category_name,
  } = group_categorization || {};

  const handleDismiss = () => {
    dispatch(closeSimilarTxnsSnackbar());
  };

  const handleApply = () => {
    dispatch(closeSimilarTxnsSnackbar());
    dispatch(openSimilarTxnsModal());
  };

  return (
    <Snackbar isOpen={isSnackbarOpen} onClose={handleDismiss}>
      <div className="t-flex t-items-center t-gap-6">
        <div className="t-flex t-flex-1 t-items-center">
          <div className="t-flex t-flex-col">
            <p className="t-m-0 t-text-subtitle t-text-text-60">
              {pluralize(
                similar_merchant_txns_count || 0,
                "similar transaction",
                "similar transactions"
              )}{" "}
              found
            </p>
            <p className="t-m-0 t-text-body-sm t-text-text-30 ">
              Apply "{transaction_category_name}" to{" "}
              {similar_merchant_txns_count} uncategorized
              <br />
              {merchant_data_name}{" "}
              {pluralize(
                similar_merchant_txns_count || 0,
                "transaction",
                "transactions",
                false
              )}
            </p>
          </div>
        </div>
        <div className="t-flex t-items-center t-gap-3">
          <Button customType="primary" size="small" onClick={handleApply}>
            Apply
          </Button>
          <Button customType="secondary" size="small" onClick={handleDismiss}>
            Dismiss
          </Button>
        </div>
      </div>
    </Snackbar>
  );
};
